import { OEMSCANLIST_CONSTANTS } from "../constants/oemscanlistConstants";

const initialState = {
  loading: false,
  oemScanList: [],
  oemNames: [],
  pagination: {},
  error: null,
};

const oemscanlistReducer = (state = initialState, action) => {
  switch (action.type) {
    case OEMSCANLIST_CONSTANTS.GET_OEM_SCAN_LIST_REQUEST:
      return { ...state, loading: true, oemScanList: [], error: null };
    case OEMSCANLIST_CONSTANTS.GET_OEM_SCAN_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        oemScanList: action.payload.response || [],
        pagination: action.payload.pagination || {},
        error: null,
      };
    case OEMSCANLIST_CONSTANTS.GET_OEM_SCAN_LIST_FAILURE:
      return { ...state, error: action.payload };
    case OEMSCANLIST_CONSTANTS.GET_OEM_NAMES_BY_ALMATA_REQUEST:
      return { ...state, oemNames: [] };
    case OEMSCANLIST_CONSTANTS.GET_OEM_NAMES_BY_ALMATA_SUCCESS:
      return { ...state, oemNames: action.payload || [] };
    case OEMSCANLIST_CONSTANTS.GET_OEM_NAMES_BY_ALMATA_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

export default oemscanlistReducer;
